import { useCallback } from 'react';
import { ChannelEnum, TemplateEnum } from '@ibk/shared-types';
import { useSendPhoneTokenMutation } from '../../services';
import { useAccountData } from './useAccountData';
export function usePhoneValidation() {
    const { cpf, deviceId } = useAccountData();
    const [sendPhoneToken, { isLoading }] = useSendPhoneTokenMutation();
    const handleSendPhoneToken = useCallback(async () => {
        if (!deviceId || !cpf) {
            throw new Error('deviceId ou CPF não encontrado');
        }
        const cleanDocumentNumber = cpf.replace(/\D/g, '');
        const result = await sendPhoneToken({
            deviceId,
            templateId: TemplateEnum.VALIDATION_TOKEN_TEMPLATE,
            documentNumber: cleanDocumentNumber,
            channel: ChannelEnum.phone,
        }).unwrap();
        return result;
    }, [cpf, deviceId, sendPhoneToken]);
    return {
        handleSendPhoneToken,
        isLoading,
    };
}
